export default "__VITE_ASSET__yNbWvH9x__"